var exports = {
  "nV": "xe533113f--657c72--gallery",
  "q9": "xe533113f--657c72--price",
  "hl": "xe533113f--657c72--address",
  "qT": "xe533113f--657c72--features",
};

module.exports = exports;
